@if (open() && agents().length) {
  <div
    class="fixed inset-x-3 top-[calc(var(--header-height,5rem)+0.5rem)] z-50 rounded-xl border border-steel-10 bg-white shadow-popover md:absolute md:inset-x-auto md:top-full md:right-0 md:mt-2 md:w-80"
    [animate.enter]="'rma-animate-panel-in'"
    animate.leave="rma-animate-panel-out"
  >
    <span
      class="absolute -top-1.5 right-5 hidden h-3 w-3 rotate-45 border-t border-l border-steel-10 bg-white md:block"
      aria-hidden="true"
    ></span>

    <div class="flex items-center justify-between gap-2 px-4 pt-4 pb-2">
      <h2 class="m-0 text-sm font-bold text-steel-100">{{ heading() }}</h2>
    </div>

    <ul class="m-0 max-h-72 list-none overflow-y-auto px-2 py-0">
      @for (agent of agents(); track agent.agentCode) {
        <li
          class="flex items-center gap-3 rounded-lg px-2 py-2"
          [class.rma-animate-row-added]="agent.agentCode === addedAgentCode()"
        >
          <rma-profile-avatar class="h-9 w-9 shrink-0" [avatar]="agent.avatarImage" [name]="agent.agentName" [lazyLoad]="true" />

          <span class="min-w-0 grow truncate text-sm text-steel-90">{{ agent.agentName }}</span>

          <button
            type="button"
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-steel-50 hover:bg-steel-5 hover:text-steel-90"
            [attr.aria-label]="removeLabel() + ' ' + agent.agentName"
            (click)="remove.emit(agent.agentCode)"
          >
            <rma-icon glyph="close" size="extraSmall" />
          </button>
        </li>
      }
    </ul>

    <div class="px-4 pt-2 pb-4">
      @if (canCompare()) {
        <button type="button" class="w-full" mat-flat-button color="primary" (click)="compare.emit()">{{ compareLabel() }}</button>
      } @else {
        <p class="m-0 text-center text-sm text-steel-60">{{ singleHint() }}</p>
      }
    </div>
  </div>
}
